module.exports = __webpack_public_path__ + "img/12-2024.21187358.jpg";